export default "__VITE_ASSET__DOMafacW__"